angular.module('Itao.IndicatorMap').directive('yearCheckboxes', function (mapConfig, $interval) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'yearCheckboxes.html',
    restrict: 'E',
    scope: {
      disabledDataLayers: '=',
      layers: '=',
      selectedIndicator: '='
    },
    link: function (scope) {
      scope.years = [];
      // Toggle selection for a given fruit by name
      scope.toggleSelection = function toggleSelection(year) {
        var dataLayer = scope.layers[year];
        var index = scope.disabledDataLayers.indexOf(dataLayer.year);
        if (index !== -1) {
          scope.disabledDataLayers.splice(index, 1);
        } else {
          scope.disabledDataLayers.push(dataLayer.year);
        }
      };

      scope.$watch('selectedIndicator', function (selectedIndicator) {
        if (scope.layers) {
          saveYearsInsideArray();
        }
      });

      function filterYearsByIndicator() {
        angular.forEach(scope.layers, function (layer, year) {
          if (layer.indicators.indexOf(scope.selectedIndicator.uid) === -1) {
            if(scope.disabledDataLayers.indexOf(layer.year) === -1) scope.disabledDataLayers.push(layer.year);
            scope.years.splice(scope.years.indexOf(layer.year), 1);
          } else {
            if(scope.disabledDataLayers.indexOf(layer.year) !== -1) scope.disabledDataLayers.splice(scope.disabledDataLayers.indexOf(layer.year), 1);
          }
        });
      }

      scope.$watchCollection('layers', function () {
        saveYearsInsideArray();
      });

      function saveYearsInsideArray() {
        if(!scope.layers) return;
        scope.years = Object.keys(scope.layers);
        if (scope.selectedIndicator) {
          filterYearsByIndicator();
        }
      }
    }
  };
});
